import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { outline } from '@/helpers/online';
import { faqappend, getcounted } from '@/redux/faq/action';
import { IM_CTX, IM_FAQ, IM_MESSAGE } from '@/typings/global';
import { MyThunkResult } from '@/typings/reducer';

interface IProps extends IM_MESSAGE {
    title: string;
    className: string;
    initList: IM_CTX[] | IM_FAQ[];
}
function QuestionList({ type, message, title, initList, className }: IProps): JSX.Element {
    const change_size = 4;
    const [start_pos, setStartPos] = useState(0);
    const dispatch: MyThunkResult<Promise<any>, any> = useDispatch();
    const { can_faq } = useSelector(
        ({ FaqReducer }) => ({
            can_faq: FaqReducer.can_faq
        }),
        shallowEqual
    );

    // 换一批
    const handleChangeQuestion = () => {
        const _start_pos = start_pos + change_size;
        if (_start_pos >= initList.length) {
            setStartPos(0);
            return;
        }
        setStartPos(_start_pos);
    };
    // 点击问题
    const _handleClickQuestion = async (item) => {
        if (outline()) return;
        await dispatch(faqappend({ message: item.title, type: 'out' }));
        const { log_id } = await dispatch(getcounted({ faq_id: item.id, pid: item.log_id }));
        await dispatch(faqappend({ message, type: 'faq-resolve', ctx: { ...item, log_id } }));
    };
    return (
        <div
            className={classnames(`im-question ${className}`, {
                'disable-ques': !can_faq,
                'has-msg': !!message && type === 'faq-init'
            })}
        >
            <div className="top">
                <span className="title">{title}</span>
                {initList.length > 4 && (
                    <div className="change" onClick={handleChangeQuestion}>
                        <i className="change-icon" />
                        <span className="txt">换一组</span>
                    </div>
                )}
            </div>
            <ul>
                {[...initList].slice(start_pos, start_pos + change_size).map((item, ind) => (
                    <li
                        className={classnames('qa-li', {
                            'disable-ques-btn': !can_faq
                        })}
                        key={`question${item.id}`}
                        title={item.title}
                        onClick={() => _handleClickQuestion(item)}
                    >
                        <span className="txt">{`${ind + 1}. ${item.title}`}</span>
                        <i className="icon-arrow" />
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default QuestionList;
